import React from "react";
import Table from "../../Common/Table";

import TableFields from "../../../constants/DriverTagsMappings/TableFields.json";
import { getPath, getReadableDate } from "../../../utils";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import Permission from "../../Common/Permission";

const DriverTagsMappingsList = ({ driverTagsMappingsList }) => {
  const allActions = MenuActionsMappings[MenuNames.DRIVER_TAG];

  const getFieldValue = (item, key) => {
    if (key.includes("date")) {
      return getReadableDate(item[key]);
    } else {
      return getPath(item, key, null);
    }
  };

  return (
    <Permission requiredPerms={[allActions.MAPPING_LIST]}>
      <Table
        list={driverTagsMappingsList}
        getFieldValue={getFieldValue}
        fields={TableFields}
      />
    </Permission>
  );
};

export default DriverTagsMappingsList;
